var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgGoodPracticeStatement(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 26,
    height: 26,
    viewBox: "0 0 26 26",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:#f3cd18;}.b,.c,.d{fill:#fff;}.c{stroke:#fff;}.d{stroke:#f3cd18;}.e{stroke:none;}.f{fill:none;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-43 -147)"
  }, /*#__PURE__*/React.createElement("circle", {
    className: "a",
    cx: 13,
    cy: 13,
    r: 13,
    transform: "translate(43 147)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "b",
    cx: 6.5,
    cy: 6.5,
    r: 6.5,
    transform: "translate(50 151)"
  }), /*#__PURE__*/React.createElement("g", {
    className: "c",
    transform: "translate(53.4 165.59)"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "e",
    width: 5.2,
    height: 3.9,
    rx: 1.95
  }), /*#__PURE__*/React.createElement("rect", {
    className: "f",
    x: 0.5,
    y: 0.5,
    width: 4.2,
    height: 2.9,
    rx: 1.45
  })), /*#__PURE__*/React.createElement("g", {
    className: "d",
    transform: "translate(50.8 162.99)"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "e",
    width: 10.4,
    height: 5.2,
    rx: 2
  }), /*#__PURE__*/React.createElement("rect", {
    className: "f",
    x: 0.5,
    y: 0.5,
    width: 9.4,
    height: 4.2,
    rx: 1.5
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGoodPracticeStatement);
export default __webpack_public_path__ + "static/media/good-practice-statement.a3e624c2603b99ed42d673b3b07785d9.svg";
export { ForwardRef as ReactComponent };